import gql from "graphql-tag";
import {
  productAttributeFields,
  fragmentName as productAttributeFragmentName
} from "./productAttributeFields";

export const fragmentName = "ProductFields";

export const productFields = gql`
  ${productAttributeFields}
  fragment ${fragmentName} on ProductListProduct {
    id
    name
    slug
    logo
    code
    enabled
    active
    redirect
    partner
    division {
      name
      code
      slug
      logo
      partner
    }
    featuredAttributes {
      ...${productAttributeFragmentName}
    }
    reviews {
      total
      averageValue
    }
  }
`;
